import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../../../core/guards/role.guard';
import { ComparisonComponent } from '../../../tabs/comparison/comparison.component';
import { ProductContentComponent } from '../product-content/product-content.component';
import { ProductOverviewComponent } from './product-overview.component';

const routes: Routes = [
  {
    path: '',
    component: ProductOverviewComponent,

    children: [
      {
        path: '',
        redirectTo: 'details',
        pathMatch: 'full',
      },
      {
        path: 'details',
        component: ProductContentComponent,
      },
      {
        path: 'model-comparison',
        component: ComparisonComponent,
        pathMatch: 'full',
      },
      {
        path: 'cost-comparison',
        canActivate: [RoleGuard],
        // Preload so switching to the Cost Comparison tab is instant — see SelectivePreloadStrategy.
        data: { preload: true },
        loadChildren: () => import('../../../features/cost-comparison/cost-comparison.module').then((m) => m.CostComparisonModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductOverViewRoutingModule {}
